import { Component, Input } from "@angular/core"
import { infoToast } from '../../../toaster'
import { IKeyword } from "graphql/queries/keyword.queries"
import { KeywordMutations } from "graphql/mutations/keyword.mutations"
import { FormGroup } from "@angular/forms"
import sweetAlert from '../../../bmAlert'
import remove from 'lodash-es/remove'
import { NgxFileDropEntry } from 'ngx-file-drop'
import { NgxFileDropService } from 'src/services/ngx-file-drop.service'

@Component({
  selector: 'file-manager',
  template: `
  <ngx-file-drop
    (onFileDrop)="onFileDrop($event)"
    (onFileOver)="onFileOver(true)"
    (onFileLeave)="onFileOver(false)"
    accept=".pdf"
    dropZoneClassName=""
    contentClassName="text-center">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <div class="form-fill-option-sm" [class.over]="fileOver">
        <div class="d-none d-sm-block cursor-pointer p-2"  (click)="openFileSelector()">
          <div><i class="fas fa-upload fa-2x text-info"></i></div>
          <div class="text-black">Drag and drop PDF or</div>
          <button type="button" class="btn-blank text-info">browse your computer</button>
        </div>

        <button
          (click)="openFileSelector()"
          class="d-sm-none btn secondary-outline-button btn-block">
          Upload PDF
        </button>
      </div>
    </ng-template>
  </ngx-file-drop>

  <div class="tiny-top-buffer">
    <div *ngIf="keyword?.documents">
      <div *ngFor="let doc of keyword?.documents" class="clearfix tiny-top-buffer small text-muted">
        <ng-template [ngIf]="!doc.pending" [ngIfElse]="loading">
          <a class="float-right cursor-pointer" (click)="onRemoveDoc(doc.id)">
            <span class="fas fa-times text-danger"></span>
          </a>
          <div class="text-one-line text-truncate">
            <span>
              <a href="{{ doc.fileUrl }}" target="_blank">{{ doc.name }}</a>
            </span>
          </div>
        </ng-template>
        <ng-template #loading>
          <i class="fas fa-spinner text-muted"></i>
          <span>
            &nbsp;{{ doc.name }}
          </span>
        </ng-template>
      </div>
    </div>
    <div *ngIf="tempFiles.length > 0">
      <div *ngFor="let f of tempFiles" class="clearfix tiny-top-buffer small text-muted">
        <a class="float-right cursor-pointer" (click)="onRemoveTempUpload(f.name)">
          <span class="fas fa-times text-danger"></span>
        </a>
        <div class="text-one-line text-truncate">
          <span>{{ f.name }}</span>
        </div>
      </div>
    </div>
  </div>
  `
})
export class FileManagerComponent {
  @Input() keyword: IKeyword = null;
  @Input() duplicateId: number = null;
  @Input() form: FormGroup;
  @Input() tempFiles: File[] = [];

  constructor(
    private keywordMutations: KeywordMutations,
    private fileDropService: NgxFileDropService
  ) {}

  public fileOver: boolean = false;
  onFileOver(fileOver: boolean): void {
    this.fileOver = fileOver
  }
  onFileDrop(files: NgxFileDropEntry[]): void {
    this.onFileOver(false)
    this.fileDropService.ngxFileDropToFile(files).then(file => {
      if (file.type === 'application/pdf') {
        this.fileSelected([file])
      } else {
        infoToast('Only PDFs allowed')
      }
    })
  }

  fileSelected(files: File[] | FileList): void {
    let file = files ? files[0] : null
    if (file)
      if (this.keyword && !this.duplicateId) {
        file = this.getFileWithUniqueName(file, this.keyword.documents.map(t => t.name))
        this.keywordMutations.uploadKeywordDoc({
          keyword: Object.assign({}, this.keyword, this.form.value),
          file
        })
      } else {
        this.tempFiles.push(this.getFileWithUniqueName(file, this.tempFiles.map(t => t.name)))
      }
  }

  onRemoveTempUpload(fileName: string): void {
    remove(this.tempFiles, f => f.name === fileName)
  }

  onRemoveDoc(id: number): void {
    sweetAlert.confirm({text: "Are you sure you want to delete this file?"}).then(confirm => {
      if (confirm) {
        const input = {
          customerId: this.keyword.customerId,
          keyword: Object.assign({}, this.keyword, this.form.value),
          id,
        }
        this.keywordMutations.removeKeywordDoc(input)
      }
    })
  }

  getFileWithUniqueName(file: File, usedNames: Array<string>): File {
    let newName = file.name
    const regEx = new RegExp('( [\(]{1}([0-9]+)[\)]{1})?.([a-z]+)$','gi')

    while (usedNames.indexOf(newName) >= 0) {
      let matches = regEx.exec(newName)
      newName = newName.replace(regEx, ` (${parseInt((matches[2] || 0).toString()) + 1}).${matches[3]}`)
    }

    try {
      return new File([file.slice(0, file.size, file.type)], newName)
    } catch (e) {
      return file
    }
  }
}
